import type { QueryClient } from "@tanstack/react-query";
import mitt from "mitt";

import type { TourId } from "./tourguide.types";

export type TourGuideEventPayload = {
  tourId: TourId;
  [key: string]: unknown;
};

export interface TourGuideEvent<
  TPayload extends TourGuideEventPayload = TourGuideEventPayload,
> {
  type: string;
  payload: TPayload;
}

export interface TourGuideStepEventActionContext<
  TPayload extends TourGuideEventPayload = TourGuideEventPayload,
> {
  event: TourGuideEvent<TPayload>;
  queryClient: QueryClient;
}

export type TourGuideStepEventAction<
  TPayload extends TourGuideEventPayload = TourGuideEventPayload,
> = (
  context: TourGuideStepEventActionContext<TPayload>,
) => boolean | void | Promise<boolean | void>;

export interface TourGuideStepEventActionConfig {
  event: string;
  action?: TourGuideStepEventAction;
  matches?: (event: TourGuideEvent) => boolean;
}

type TourGuideBusEvents = {
  event: TourGuideEvent;
};

export const tourGuideBus = mitt<TourGuideBusEvents>();

export function emitTourGuideEvent<TPayload extends TourGuideEventPayload>(
  event: TourGuideEvent<TPayload>,
) {
  tourGuideBus.emit("event", event);
}
